// @ts-nocheck

/**
 * YPM_UOM_V_CDS
 * UoM  ## Entity Data Model ![ER Diagram](https://yuml.me/diagram/class/[YPM_UOM_VType{bg:orange}],[YPM_UOM_V{bg:dodgerblue}]++-*>[YPM_UOM_VType])  ### Legend ![Legend](https://yuml.me/diagram/plain;dir:TB;scale:60/class/[External.Type{bg:whitesmoke}],[ComplexType],[EntityType{bg:orange}],[EntitySet/Singleton/Operation{bg:dodgerblue}])
 *
 * The version of the OpenAPI document: 0001
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ModelError } from '../model/models';
import { Wrapper } from '../model/models';
import { YPMUOMVType } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class YPMUOMVService {

    protected basePath = 'https://dkasub.corp.lego.com:1443/sap/opu/odata/sap/YPM_UOM_V_CDS';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Get entities from YPM_UOM_V
     * @param $top Show only the first n items, see [Paging - Top](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;66)
     * @param $skip Skip the first n items, see [Paging - Skip](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;65)
     * @param $filter Filter items by property values, see [Filtering](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;64)
     * @param $inlinecount Include count of items, see [Inlinecount](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;67)
     * @param $orderby Order items by property values, see [Sorting](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;65)
     * @param $select Select properties to be returned, see [Select](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;68)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public yPMUOMVGet($top?: number, $skip?: number, $filter?: string, $inlinecount?: 'allpages' | 'none', $orderby?: Array<'materialNumber' | 'materialNumber desc' | 'weightUnit' | 'weightUnit desc' | 'altUnit' | 'altUnit desc' | 'length' | 'length desc' | 'width' | 'width desc' | 'height' | 'height desc' | 'unitOfDimension' | 'unitOfDimension desc' | 'volume' | 'volume desc' | 'volumeUnit' | 'volumeUnit desc' | 'grossWeight' | 'grossWeight desc'>, $select?: Array<'materialNumber' | 'weightUnit' | 'altUnit' | 'length' | 'width' | 'height' | 'unitOfDimension' | 'volume' | 'volumeUnit' | 'grossWeight'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Wrapper>;
    public yPMUOMVGet($top?: number, $skip?: number, $filter?: string, $inlinecount?: 'allpages' | 'none', $orderby?: Array<'materialNumber' | 'materialNumber desc' | 'weightUnit' | 'weightUnit desc' | 'altUnit' | 'altUnit desc' | 'length' | 'length desc' | 'width' | 'width desc' | 'height' | 'height desc' | 'unitOfDimension' | 'unitOfDimension desc' | 'volume' | 'volume desc' | 'volumeUnit' | 'volumeUnit desc' | 'grossWeight' | 'grossWeight desc'>, $select?: Array<'materialNumber' | 'weightUnit' | 'altUnit' | 'length' | 'width' | 'height' | 'unitOfDimension' | 'volume' | 'volumeUnit' | 'grossWeight'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Wrapper>>;
    public yPMUOMVGet($top?: number, $skip?: number, $filter?: string, $inlinecount?: 'allpages' | 'none', $orderby?: Array<'materialNumber' | 'materialNumber desc' | 'weightUnit' | 'weightUnit desc' | 'altUnit' | 'altUnit desc' | 'length' | 'length desc' | 'width' | 'width desc' | 'height' | 'height desc' | 'unitOfDimension' | 'unitOfDimension desc' | 'volume' | 'volume desc' | 'volumeUnit' | 'volumeUnit desc' | 'grossWeight' | 'grossWeight desc'>, $select?: Array<'materialNumber' | 'weightUnit' | 'altUnit' | 'length' | 'width' | 'height' | 'unitOfDimension' | 'volume' | 'volumeUnit' | 'grossWeight'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Wrapper>>;
    public yPMUOMVGet($top?: number, $skip?: number, $filter?: string, $inlinecount?: 'allpages' | 'none', $orderby?: Array<'materialNumber' | 'materialNumber desc' | 'weightUnit' | 'weightUnit desc' | 'altUnit' | 'altUnit desc' | 'length' | 'length desc' | 'width' | 'width desc' | 'height' | 'height desc' | 'unitOfDimension' | 'unitOfDimension desc' | 'volume' | 'volume desc' | 'volumeUnit' | 'volumeUnit desc' | 'grossWeight' | 'grossWeight desc'>, $select?: Array<'materialNumber' | 'weightUnit' | 'altUnit' | 'length' | 'width' | 'height' | 'unitOfDimension' | 'volume' | 'volumeUnit' | 'grossWeight'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($top !== undefined && $top !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$top, '$top');
        }
        if ($skip !== undefined && $skip !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$skip, '$skip');
        }
        if ($filter !== undefined && $filter !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$filter, '$filter');
        }
        if ($inlinecount !== undefined && $inlinecount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$inlinecount, '$inlinecount');
        }
        if ($orderby) {
            queryParameters = this.addToHttpParams(queryParameters,
                $orderby.join(COLLECTION_FORMATS['csv']), '$orderby');
        }
        if ($select) {
            queryParameters = this.addToHttpParams(queryParameters,
                $select.join(COLLECTION_FORMATS['csv']), '$select');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Wrapper>(`${this.configuration.basePath}/YPM_UOM_V`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get entity from YPM_UOM_V by key
     * @param materialNumber Material Number   Alphanumeric key uniquely identifying the material.
     * @param altUnit Alternative Unit of Measure for Stockkeeping Unit   Unit of measure in which quantities can be entered alternatively to the base unit of measure / stockkeeping unit.
     * @param $select Select properties to be returned, see [Select](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;68)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public yPMUOMVMaterialNumbermaterialNumberaltUnitaltUnitGet(materialNumber: string, altUnit: string, $select?: Array<'materialNumber' | 'weightUnit' | 'altUnit' | 'length' | 'width' | 'height' | 'unitOfDimension' | 'volume' | 'volumeUnit' | 'grossWeight'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<YPMUOMVType>;
    public yPMUOMVMaterialNumbermaterialNumberaltUnitaltUnitGet(materialNumber: string, altUnit: string, $select?: Array<'materialNumber' | 'weightUnit' | 'altUnit' | 'length' | 'width' | 'height' | 'unitOfDimension' | 'volume' | 'volumeUnit' | 'grossWeight'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<YPMUOMVType>>;
    public yPMUOMVMaterialNumbermaterialNumberaltUnitaltUnitGet(materialNumber: string, altUnit: string, $select?: Array<'materialNumber' | 'weightUnit' | 'altUnit' | 'length' | 'width' | 'height' | 'unitOfDimension' | 'volume' | 'volumeUnit' | 'grossWeight'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<YPMUOMVType>>;
    public yPMUOMVMaterialNumbermaterialNumberaltUnitaltUnitGet(materialNumber: string, altUnit: string, $select?: Array<'materialNumber' | 'weightUnit' | 'altUnit' | 'length' | 'width' | 'height' | 'unitOfDimension' | 'volume' | 'volumeUnit' | 'grossWeight'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (materialNumber === null || materialNumber === undefined) {
            throw new Error('Required parameter materialNumber was null or undefined when calling yPMUOMVMaterialNumbermaterialNumberaltUnitaltUnitGet.');
        }
        if (altUnit === null || altUnit === undefined) {
            throw new Error('Required parameter altUnit was null or undefined when calling yPMUOMVMaterialNumbermaterialNumberaltUnitaltUnitGet.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($select) {
            queryParameters = this.addToHttpParams(queryParameters,
                $select.join(COLLECTION_FORMATS['csv']), '$select');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<YPMUOMVType>(`${this.configuration.basePath}/YPM_UOM_V(materialNumber='${encodeURIComponent(String(materialNumber))}',altUnit='${encodeURIComponent(String(altUnit))}')`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
